export default string => string.replace(/\\(.)/g, '$1');